import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_NAME = "AC WARDEN";
let cachedName = null;

// Nombre de marca actual (!newname desde WhatsApp) -- se carga una vez de
// /api/branding (misma Mongo que el bot) y se cachea en memoria para el
// resto de la sesión del navegador.
export function useBranding() {
  const [name, setName] = useState(cachedName || DEFAULT_NAME);

  useEffect(() => {
    if (cachedName) return;
    api.branding()
      .then((data) => {
        cachedName = data?.name || DEFAULT_NAME;
        setName(cachedName);
      })
      .catch(() => { /* mantiene el nombre por defecto si la API no responde */ });
  }, []);

  return name;
}
